export const submissionTranslation = {
  en: {
    "Total Submissions": "Total Submissions",
    "Completed Submissions": "Completed Submissions",
    "Declined Submissions": "Declined Submissions",
    "Pending Submissions": "Pending Submissions",
    "User Name": "User Name",
    "File Link": "File Link",
    "Is Archived": "Is Archived",
    "Party Numbers": "Party Numbers",
    "Created At": "Created At",
    "last update": "Last Update",
    Status: "Status",
    Actions: "Actions",
    Search: "Search",
    Home: "Home",
    Submissions: "Submissions",
    "Are you sure you want to delete this submission?":
      "Are you sure you want to delete this submission?",
    "This action cannot be undone.": "This action cannot be undone.",
    Cancel: "Cancel",
    Delete: "Delete",
    "Choose date range for submissions": "Choose date range for submissions",
    "Submission Token": "Submission Token",
    "Submission token copied to clipboard!":
      "Submission token copied to clipboard!",
    "Failed to copy submission token": "Failed to copy submission token",
    "Failed to get download link.": "Failed to get download link.",
    "Origin Files": "Origin Files",
    "Copy Submission Token": "Copy Submission Token",
    "Reference No.": "Reference No.",
    Teams: "Teams",
    Download: "Download",
    "Download PDF": "Download PDF",
    "Download Excel": "Download Excel",
    "Rows per page": "Rows per page",
    of: "of",
    All: "All",
    "There are no records to display": "There are no records to display",
    Clear: "Clear",
    Party: "Party",
    Name: "Name",
    Role: "Role",
    "No recipients found.": "No recipients found.",
    "Copy UUID": "Copy UUID",
    "Not available": "Not available",
    Close: "Close",
    "Choose date range for report": "Choose date range for report",
    Information: "Information",
    "No information available": "No information available",
    "Field Type": "Field Type",
    "UUID copied to clipboard!": "UUID copied to clipboard!",
    "Parties of Submission": "Parties of Submission",
    Fields: "Fields",
    "Field Value": "Field Value",
    "Enter Name": "Enter Name",
    "Enter Email": "Enter Email",
    "Enter Phone": "Enter Phone",
    Verify: "Verify",
    "Select Method": "Select Method",
    "View Recipients of Submission": "View Recipients of Submission",
    "Add Party": "Add Party",
    Remove: "Remove",
    Value: "Value",
    "Preview:": "Preview:",
    "View link": "View link",
    "Display Title (Optional)": "Display Title (Optional)",
    "Select field": "Select field",
    "Add condition": "Add condition",
    "Enter Description": "Enter Description",
    "Enter Display Title": "Enter Display Title",
    Template: "Template",
    "Select template": "Select template",
    "Loading templates...": "Loading templates...",
    "Select status": "Select status",
    "Select tool": "Select tool",
    "No templates found": "No templates found",
    "Copy Template ID": "Copy Template ID",
    "Template ID copied to clipboard!": "Template ID copied to clipboard!",
    "Failed to copy template id": "Failed to copy template id",
    "Signature": "Signature",
    "Initial": "Initial",
    "Date": "Date",
    "Text": "Text",
    "Number": "Number",
    "Image": "Image",
    "Multiple": "Multiple",
    "File": "File",
    "Radio": "Radio",
    "Cell": "Cell",
    "Stamp": "Stamp",
    "Phone": "Phone",
    "Email": "Email",
    "Url": "Url",
    "Payment": "Payment",
    "Submission ID copied to clipboard!": "Submission ID copied to clipboard!",
    "Failed to copy submission id": "Failed to copy submission id",
    "Copy Submission ID": "Copy Submission ID",
    "Audit Log": "Audit Log",
    "Audit log is not available until this submission is completed.":
      "Audit log is not available until this submission is completed.",
  },
  ar: {
    "Total Submissions": "إجمالي التقديمات",
    "Completed Submissions": "التقديمات المكتملة",
    "Declined Submissions": "التقديمات المرفوضة",
    "Pending Submissions": "التقديمات المعلقة",
    "User Name": "اسم المستخدم",
    "File Link": "رابط الملف",
    "Is Archived": "مؤرشف",
    "Party Numbers": "عدد الأطراف",
    "Created At": "تاريخ الإنشاء",
    "last update": "آخر تحديث",
    Status: "الحالة",
    Actions: "إجراءات",
    Search: "بحث",
    Home: "الرئيسية",
    Submissions: "التقديمات",
    "Are you sure you want to delete this submission?":
      "هل أنت متأكد أنك تريد حذف هذا التقديم؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Cancel: "إلغاء",
    Delete: "حذف",
    "Choose date range for submissions": "اختر نطاق التاريخ للتقديمات",
    "Submission Token": "رمز التقديم",
    "Submission token copied to clipboard!": "تم نسخ رمز التقديم إلى الحافظة!",
    "Failed to copy submission token": "فشل في نسخ رمز التقديم",
    "Failed to get download link.": "فشل في الحصول على رابط التنزيل.",
    "Origin Files": "الملفات الأصلية",
    "Copy Submission Token": "نسخ رمز التقديم",
    "Reference No.": "رقم المرجع",
    Teams: "الفرق",
    Download: "تنزيل",
    "Download PDF": "تنزيل PDF",
    "Download Excel": "تنزيل Excel",
    "Rows per page": "عدد الصفوف في الصفحة",
    of: "من",
    All: "الكل",
    "There are no records to display": "لا توجد سجلات للعرض",
    Clear: "مسح",
    Party: "طرف",
    Name: "الاسم",
    Role: "الدور",
    "No recipients found.": "لم يتم العثور على مستلمين.",

    "Copy UUID": "نسخ UUID",
    "Not available": "غير متوفر",
    Close: "إغلاق",
    "Choose date range for report": "اختر نطاق التاريخ للتقرير",
    Information: "معلومات",
    "No information available": "لا توجد معلومات متاحة",
    "UUID copied to clipboard!": "تم نسخ UUID إلى الحافظة!",
    "Parties of Submission": "أطراف التقديم",
    Fields: "الحقول",
    "Field Type": "نوع الحقل",
    "Field Value": "قيمة الحقل",
    "Enter Name": "أدخل الاسم",
    "Enter Email": "أدخل البريد الإلكتروني",
    "Enter Phone": "أدخل الهاتف",
    Verify: "تحقق",
    "Select Method": "اختر الطريقة",
    "View Recipients of Submission": "عرض مستلمي التقديم",
    "Add Party": "إضافة طرف",
    Remove: "إزالة",
    Value: "القيمة",
    "Preview:": "معاينة:",
    "View link": "عرض الرابط",
    "Display Title (Optional)": "عنوان العرض (اختياري)",
    "Select field": "اختر الحقل",
    "Add condition": "إضافة شرط",
    "Enter Description": "أدخل الوصف",
    "Enter Display Title": "أدخل عنوان العرض",
    Template: "القالب",
    "Select template": "اختر القالب",
    "Loading templates...": "جارٍ تحميل القوالب...",
    "Select status": "اختر الحالة",
    "Select tool": "اختر الأداة",
    "No templates found": "لم يتم العثور على قوالب",
    "Copy Template ID": "نسخ معرف القالب",
    "Template ID copied to clipboard!": "تم نسخ معرف القالب إلى الحافظة!",
    "Failed to copy template id": "فشل في نسخ معرف القالب",
    "Signature": "التوقيع",
    "Initial": "الحرف الأول",
    "Date": "التاريخ",
    "Text": "النص",
    "Number": "الرقم",
    "Image": "الصورة",
    "Multiple": "متعدد",
    "File": "الملف",
    "Radio": "راديو",
    "Cell": "خلية",
    "Stamp": "ختم",
    "Phone": "الهاتف",
    "Email": "البريد الإلكتروني",
    "Url": "الرابط",
    "Payment": "الدفع",
    "Submission ID copied to clipboard!": "تم نسخ معرف التقديم إلى الحافظة!",
    "Failed to copy submission id": "فشل في نسخ معرف التقديم",
    "Copy Submission ID": "نسخ معرف التقديم",
    "Audit Log": "سجل التدقيق",
    "Audit log is not available until this submission is completed.":
      "سجل التدقيق غير متاح حتى يكتمل هذا التقديم.",
  },
};
